export const returnS3imageViewUsingUrlCutting = (url) => {
    let img = url;
    let setImage = String(img).split("?");
    console.log(setImage[0], "setImage");
    return setImage[0];
}